import React from 'react';
import { useDispatch } from 'react-redux';
// Style
import './ComponentsAccordion.scss';
import { showModalForDomainPart } from '../DomainModalGrid/actions';

const STATUS_COMPONENTS = [
  <span className="component-na component-status fs--b-base">N/A</span>,
  <span className="component-init component-status fs--b-base">INIT</span>,
  <span className="component-ok component-status fs--b-base">OK</span>,
  <span className="component-error component-status fs--b-base">ERROR</span>,
];

/** ComponentsAccordion component */
function ComponentsAccordion({ domainData }) {
  const dispatch = useDispatch();

  const renderComponent = (currentComponent) => {
    const statusComponent = STATUS_COMPONENTS[currentComponent.status];
    return (
      <div
        key={currentComponent.componentIdentifier}
        className="component-wrapper"
      >
        <button
          className="component-label-btn fs--b-base"
          onClick={() => {
            dispatch(
              showModalForDomainPart(currentComponent.componentIdentifier),
            );
          }}
        >
          {currentComponent.componentLabel}
        </button>
        {statusComponent || (
          <span className="component-ok component-status fs--b-base">OK</span>
        )}
      </div>
    );
  };
  return (
    <div className="components-accordion">
      {domainData.map((currentComponent) => {
        return renderComponent(currentComponent);
      })}
    </div>
  );
}
export default ComponentsAccordion;
